import { call } from '@apparel/core/utils/functions';
import Button, { ButtonProps } from '@material-ui/core/Button';
import React, { useCallback } from 'react';
import { useNavigation } from '../navigation/useNavigation';
import { CartEmitter, CartEvents } from './CartEmitter';

export const CartReview = React.memo(({ onClick, ...rest }: ButtonProps) => {
    const { LinkComponent, cleanPathUrl } = useNavigation();

    const handleClick = useCallback(
        (e) => {
            call(onClick, e);
            CartEmitter.emit(CartEvents.DROPDOWN_SHOW, false);
        },
        [onClick],
    );

    const getAction$ = () => '/platform/my-cart/review';

    return (
        <Button
            disableElevation
            component={LinkComponent}
            color={'primary'}
            variant={'contained'}
            to={cleanPathUrl(getAction$())}
            onClick={handleClick}
            {...rest}
        >
            View
        </Button>
    );
});

export default CartReview;
